import { AVATAR_CREDIT } from './CustomerAvatar'
import { Icon } from './icons'

const META: Record<string, { t: string; d: string; icon: keyof typeof import('./icons').ICONS }> = {
  clientes: {
    t: 'Clientes',
    d: 'Base unificada de clientes com identidades de todos os canais, histórico de compras e conversas. Nesta versão, os dados do cliente estão disponíveis no painel de contexto da conversa.',
    icon: 'user',
  },
  pedidos: {
    t: 'Pedidos',
    d: 'Pedidos de todos os marketplaces e do site em uma lista só, com status de logística e ações de troca, reenvio e reembolso. Nesta versão, os pedidos aparecem dentro da conversa.',
    icon: 'box',
  },
  relatorios: {
    t: 'Relatórios',
    d: 'Volume por canal, tempo de primeira resposta, SLA, desempenho por agente e desempenho da IA.',
    icon: 'chart',
  },
  config: {
    t: 'Configurações',
    d: 'Contas e canais conectados, equipe, horários de atendimento, respostas rápidas e políticas.',
    icon: 'gear',
  },
}

export function PlaceholderSection({ section }: { section: string }) {
  const m = META[section] ?? META.clientes!
  return (
    <div className="ph">
      <div className="ph-in">
        <div className="ph-ic">
          <Icon name={m.icon} />
        </div>
        <h2>{m.t}</h2>
        <p>{m.d}</p>
        {/* CC BY 4.0 requires the creator to be credited wherever the artwork appears. This is
            that credit — removing it means we lose the right to use the avatars. */}
        {section === 'config' && (
          <p className="credit">
            Avatares de clientes: “Fun Emoji” por{' '}
            <a href={AVATAR_CREDIT.creatorUrl} target="_blank" rel="noreferrer noopener">
              {AVATAR_CREDIT.creator}
            </a>
            , sob{' '}
            <a href={AVATAR_CREDIT.licenseUrl} target="_blank" rel="noreferrer noopener">
              {AVATAR_CREDIT.license}
            </a>
            , via DiceBear.
          </p>
        )}
      </div>
    </div>
  )
}
